import React from "react";
import Modal from "react-bootstrap/Modal";
import { X } from "lucide-react";
import styles from "../../_css/ContenetManagement.module.css";

const WatchVideoModal = ({ show, onHide, videoData }) => {
    if (!videoData) return null;

    const videoUrl = videoData.ctaLink || videoData.link || "";
    const title = videoData.title || videoData.subHeading;

    // Convert YouTube URL to embeddable format
    const getEmbedUrl = (url) => {
        if (!url) return "";
        try {
            if (url.includes("watch?v=")) {
                return url.replace("watch?v=", "embed/");
            } else if (url.includes("youtu.be/")) {
                return url.replace("youtu.be/", "www.youtube.com/embed/");
            }
            return url;
        } catch (err) {
            console.error("Invalid YouTube URL:", err);
            return url;
        }
    };

    const isYouTubeUrl = videoUrl.includes("youtube.com") || videoUrl.includes("youtu.be");
    const embedUrl = isYouTubeUrl ? getEmbedUrl(videoUrl) : videoUrl;

    return (
        <Modal show={show} onHide={onHide} centered size="lg" dialogClassName="modal-50">
            <Modal.Body>
                <div className={styles.watchVideoModalContainer}>
                    {/* Header */}
                    <div className={styles.watchVideoHeader}>
                        <span className={styles.watchVideoTitle}>{title}</span>
                        <X onClick={onHide} className={styles.watchVideoCloseIcon} />
                    </div>

                    {/* Video / YouTube Player */}
                    <div className={styles.videoPlayerContainer}>
                        {videoUrl ? (
                            isYouTubeUrl ? (
                                <iframe
                                    width="100%"
                                    height="400"
                                    src={embedUrl}
                                    title={title}
                                    frameBorder="0"
                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                    allowFullScreen
                                    className={styles.videoPlayer}
                                ></iframe>
                            ) : (
                                <video
                                    controls
                                    autoPlay
                                    className={styles.videoPlayer}
                                    poster={videoData.thumbnail || ""}
                                >
                                    <source src={embedUrl} type="video/mp4" />
                                    <source src={embedUrl} type="video/webm" />
                                    <source src={embedUrl} type="video/ogg" />
                                    Your browser does not support the video tag.
                                </video>
                            )
                        ) : (
                            <div className={styles.noVideoMessage}>Video URL not available</div>
                        )}
                    </div>

                    {/* Video Details */}
                    <div className={styles.videoDetails}>
                        <h3 className={styles.videoDetailTitle}>{title}</h3>
                        <p className={styles.videoSpeaker}>
                            By {videoData.speaker || "Tutorial Video"}
                        </p>
                        <p className={styles.videoDuration}>
                            Duration: {videoData.duration || "Not specified"}
                        </p>
                        {videoData.description && (
                            <p className={styles.videoDescription}>{videoData.description}</p>
                        )}
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default WatchVideoModal;
